import { Modal, Table } from "antd";
import React from "react";
import { MaterialStockItem, useGetMaterialItemsQuery } from "shared/api";

interface ParentItemsModalProps {
  open: boolean;
  onClose: () => void;
  parentSourceId: number | null;
  columns: any[];
}

export const ParentItemsModal: React.FC<ParentItemsModalProps> = ({
  open,
  onClose,
  parentSourceId,
  columns,
}) => {
  const { data: parents, isLoading } = useGetMaterialItemsQuery(
    parentSourceId
      ? {
          child_material_item: parentSourceId,
          expand:
            "moved_to_order,material_stock_batch.material.material_category,material_stock_batch.material,order_production_set.order_process_step_tracker.order",
        }
      : {},
    { skip: !parentSourceId }
  );

  const parentsList: MaterialStockItem[] = Array.isArray(parents)
    ? parents
    : [];

  return (
    <Modal
      title="Parent Items"
      open={open}
      onCancel={onClose}
      width={1400}
      footer={null}
    >
      <Table
        loading={isLoading}
        dataSource={parentsList}
        rowKey={(row) => row.id}
        columns={columns}
        pagination={false}
      />
    </Modal>
  );
};
